import LzMCrud from '@lz-models/crud/Crud';
import PartyModel from './party.model';

const config = new LzMCrud({
    ident: 'parties',
    baseRoute: '/params/parties',
    fields: {
        type: { type: 'number', required: true, default: 1 },
        code: { size: 10, type: 'string', required: true },
        name: { size: 100, type: 'string', required: true },
        address: { size: 255, type: 'string' },
        province: { size: 20, type: 'string', required: true, default: PartyModel.PROVINCE_SINDH },
        strn: { size: 50, type: 'string' },
        ntn: { size: 50, type: 'string' },
        cnic: { size: 50, type: 'string' },
        is_active: { type: 'boolean', default: true },
    },
    listingColumns: {
        type: { label: 'Type', sortable: true, alignment: 'left', displayFunction: (val) => PartyModel.getTypeName(val) },
        code: { label: 'Code', sortable: true, alignment: 'left' },
        name: { label: 'Name', sortable: true, alignment: 'left' },
        ntn: { label: 'NTN #', sortable: true, alignment: 'left' },
    },
    addFormInputs: {
        type: { label: 'Type', type: 'select', options: PartyModel.getTypeOptions() },
        code: { label: 'Code' },
        name: { label: 'Name' },
        address: { label: 'Address', multiline: true },
        province: { label: 'Province', type: 'select', options: PartyModel.getProvinceOptions() },
        strn: { label: 'Sales Tax Reg. No.' },
        ntn: { label: 'NTN No.' },
        cnic: { label: 'CNIC No.' },
        is_active: { label: 'Active', type: 'switch' },
    },
    viewFormFields: {
        type: { label: 'Type', displayFunction: (val) => PartyModel.getTypeName(val) },
        code: { label: 'Code' },
        name: { label: 'Name' },
        address: { label: 'Address' },
        province: { label: 'Province' },
        strn: { label: 'Sales Tax Reg. No.' },
        ntn: { label: 'NTN No.' },
        cnic: { label: 'CNIC No.' },
        is_active: { label: 'Active', displayFunction: (val) => !!val ? 'Active' : 'In-Active' },
    },
    editFormInputs: {
        type: { label: 'Type', type: 'select', options: PartyModel.getTypeOptions() },
        code: { label: 'Code' },
        name: { label: 'Name' },
        address: { label: 'Address' },
        province: { label: 'Province', type: 'select', options: PartyModel.getProvinceOptions() },
        strn: { label: 'Sales Tax Reg. No.' },
        ntn: { label: 'NTN No.' },
        cnic: { label: 'CNIC No.' },
        is_active: { label: 'Active', type: 'switch' },
    },
});

export default config;
